import React, { FC, memo } from 'react';
import { Text, View } from '@react-pdf/renderer';

import styles from '../pdfStyles';
import { PdfBoxDataType } from '../Vouchers/voucherHelpers';
import { taytanFormatNumberToString } from '../../../utils/mathUtils';

type Props = {
    pdfBodyBoxData: PdfBoxDataType;
    noPadding?: boolean;
    firstViewStyle?: Array<object>;
    secondViewStyle?: Array<object>;
};
const PdfBodyBox: FC<Props> = (props: Props) => {
    const { pdfBodyBoxData, firstViewStyle = [], secondViewStyle = [] } = props;

    return (
        <View style={[styles.flexRow, styles.padding4_0, ...firstViewStyle]} wrap={false}>
            <View style={[styles.flexRowBetween, styles.padding0_2px_4px_0, ...secondViewStyle]}>
                <View style={styles.paddingRight40}>
                    {pdfBodyBoxData?.map((line, idx) => {
                        return <Text key={`${idx}-${line.label}`}>{line.label || ' '}</Text>;
                    })}
                </View>
                <View>
                    {pdfBodyBoxData?.map((line, idx) => {
                        return (
                            <Text key={`${idx}-${line.label}`}>
                                {typeof line.value === 'number'
                                    ? taytanFormatNumberToString(line.value)
                                    : line.value || ' '}
                            </Text>
                        );
                    })}
                </View>
            </View>
        </View>
    );
};

export default memo(PdfBodyBox);
